import React, {FC} from 'react'
import {KTSVG} from '_metronic/helpers'
import {Dropdown} from 'react-bootstrap'
import CustomToggle from '_core/components/CustomToggle'

type Props = {
  children?: React.ReactNode
}

const MoreButton: FC<Props> = ({children}) => {
  return (
    <Dropdown align={'end'} className='btn btn-icon btn-sm btn-color-gray-400 justify-content-end'>
      <DropDownToggle toggle={CustomToggle}>
        <KTSVG
          path='/media/icons/duotune/general/gen023.svg'
          className='svg-icon-muted svg-icon-2hx'
        />
      </DropDownToggle>
      {/* <Dropdown.Toggle as={CustomToggle} id='dropdown-custom-components'></Dropdown.Toggle> */}
      <Dropdown.Menu>{children}</Dropdown.Menu>
    </Dropdown>
  )
}

export default MoreButton

type Props2 = {
  children: any | React.ReactNode
  toggle: any
}

export const DropDownToggle: FC<Props2> = ({children, toggle}) => {
  return (
    <Dropdown.Toggle as={toggle} id='dropdown-custom-components'>
      {children}
    </Dropdown.Toggle>
  )
}
